"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Flex = _interopRequireDefault(require("../Flex"));

var _CustomStatistic = _interopRequireDefault(require("../CustomStatistic"));

var DataDisplayWidget = function DataDisplayWidget(props) {
  var size = props.size,
      value = props.value,
      title = props.title,
      icon = props.icon,
      color = props.color,
      avatarSize = props.avatarSize,
      vertical = props.vertical,
      cardHeight = props.cardHeight;
  var customStatisticProps = {
    size: size,
    value: value,
    title: title,
    cardHeight: cardHeight
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: cardHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
    alignItems: "center",
    flexDirection: vertical ? 'column' : 'row',
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    size: avatarSize,
    shape: "square",
    icon: icon,
    className: "ant-avatar-".concat(color)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: vertical ? 'mt-3 text-center' : 'ml-3'
  }, /*#__PURE__*/_react.default.createElement(_CustomStatistic.default, customStatisticProps))));
};

DataDisplayWidget.defaultProps = {
  avatarSize: 50,
  vertical: false
};
var _default = DataDisplayWidget; // import React from 'react'
// import { Card, Avatar } from 'antd'
// import Flex from '../Flex'
// import CustomStatistic from '../CustomStatistic'
// const DataDisplayWidget = props => {
// 	const { size, value, title, icon, color, avatarSize, vertical,cardSize } = props
// 	const customStatisticProps = { size, value, title }
// 	return (
// 		<Card >
// 			<Flex alignItems="center" flexDirection={vertical ? 'column' : 'row'} size={cardSize}>
// 			<div className="mt-3">
// 				<Avatar  size={avatarSize} shape="square" icon={icon} className={`ant-avatar-${color}`}/>
// 				</div>
// 				<div className={vertical ? 'mt-3 text-center' : 'ml-3'}>
// 					<CustomStatistic {...customStatisticProps}/>
// 				</div>
// 				{/* <div className="mb-">
// 				</div> */}
// 			</Flex>
// 		</Card>
// 	)
// }
// DataDisplayWidget.defaultProps = {
// 	avatarSize: 50,
// 	// cardSize:90,
// 	vertical: false
// };
// export default DataDisplayWidget

exports.default = _default;